/**
 * Evaluation kind of a dunning stop condition (DunningTypeStop): either a
 * comparison of a balance field against a threshold, or a configurable logic
 * block. If the value is missing, the runtime default BALANCE_FIELD applies
 * (combined with the balance field TOTAL).
 *
 * Mirrors backend enum {@code com.mvs.backend.bd.enums.DunningStopConditionType}.
 * Ordinal mapping (MUST match the backend enum):
 *   0 = BALANCE_FIELD
 *   1 = LOGIC
 *
 * @ticket bd-dunningtype-overview
 */
export enum DunningStopConditionType {
    BALANCE_FIELD,
    LOGIC
}

/**
 * German UI labels for DunningStopConditionType values.
 */
export const DUNNING_STOP_CONDITION_TYPE_LABELS: Record<DunningStopConditionType, string> = {
    [DunningStopConditionType.BALANCE_FIELD]: 'Saldenfeld',
    [DunningStopConditionType.LOGIC]: 'Logik'
};
